export const metersPerPixel = (zoom, lat) => {
    return (156543.03 * Math.cos(lat)) / 2 ** zoom;
};
